










 

 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemoveIntegrationProviderDialog_integrationProvider",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "service",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serverBaseUrl",
          "storageKey": null
        }
      ],
      "type": "IntegrationProviderOAuth2",
      "abstractKey": null
    }
  ],
  "type": "IntegrationProvider",
  "abstractKey": "__isIntegrationProvider"
};

(node ).hash = "c1fab0c2d9793c1b6028a08e11d1bf91";

export default node;
